import React from "react";
import Lottie from "react-lottie";
import * as loadingData from "./animation.json";
import "./DataLoading.scss";
import DataLoadingDisplay from "./DataLoading.styled";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default function DataLoading() {
  return (
    <DataLoadingDisplay>
      <Lottie
        options={defaultOptions}
        height={200}
        width={200}
        style={{
          // position: "absolute",
          margin: "auto",
          left: "0px",
          right: "0px",
          top: "0px",
          bottom: "0px",
        }}
      />
      
    </DataLoadingDisplay>
  );
}
